/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/password/custom-elements';

import { defineCustomElement as defineOsdsPassword } from '@ovhcloud/ods-stencil/components/password/custom-elements/osds-password.js';

export const OsdsPassword = /*@__PURE__*/createReactComponent<JSX.OsdsPassword, HTMLOsdsPasswordElement>('osds-password', undefined, undefined, defineOsdsPassword);
